import { render, staticRenderFns } from "./ProfileInvoicesTab.vue?vue&type=template&id=0a25699c&"
import script from "./ProfileInvoicesTab.vue?vue&type=script&lang=js&"
export * from "./ProfileInvoicesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports